import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue'

// Monospace code chip with a copy button. House pattern for gift card codes,
// promo codes, and any other value staff copy verbatim. Numeric codes are
// grouped in fours for reading; the copied value is always the raw code.

const __default__ = { name: 'code-chip' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  code: { type: String, default: '' },
  // Group digits in fours when the code is numeric (gift card style).
  group: { type: Boolean, default: true },
  copyable: { type: Boolean, default: true },
  // Noun used in the copy notification and tooltip, for example "gift card code".
  label: { type: String, default: 'code' }
},
  setup(__props) {

const props = __props



const { proxy } = getCurrentInstance() as any

const displayCode = computed(() => {
  if (!props.code) return ''
  if (!props.group || isNaN(Number(props.code))) return props.code
  const parts = props.code.match(/.{1,4}/g)
  return parts ? parts.join(' ') : props.code
})

const notification = (message: string, type: string) => ({
  message,
  type,
  icon: type === 'success' ? 'tim-icons icon-check-2' : 'tim-icons icon-alert-circle-exc',
  horizontalAlign: 'right',
  verticalAlign: 'top',
  timeout: 2000
})

async function copy() {
  const done = props.label.charAt(0).toUpperCase() + props.label.slice(1) + ' copied'
  try {
    await navigator.clipboard.writeText(props.code)
    proxy.$notify(notification(done, 'success'))
  } catch (err) {
    try {
      const textArea = document.createElement('textarea')
      textArea.value = props.code
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      proxy.$notify(notification(done, 'success'))
    } catch (fallbackErr) {
      proxy.$notify(notification('Could not copy', 'warning'))
    }
  }
}

return { __sfc: true,props, proxy, displayCode, notification, copy }
}

})